/**
 * Customer status tags, as served by the v_customer_tags view (tag_group = 'Status').
 *
 * Shared so the Plans page and the Daily round show the same tags in the same colours —
 * they were drifting apart as private copies in each component.
 */

export const STATUS_TAGS = ['Active', 'Part Paused', 'Paused', 'New', 'Inactive'];

export const statusTagColor = (tag) => {
    switch (tag) {
        case 'Active':      return 'success';
        case 'Part Paused': return 'info';
        case 'Paused':      return 'warning';
        case 'New':         return 'info';
        case 'Inactive':    return 'default';
        default:            return 'default';
    }
};

/** { customerId: statusTagName } from a getCustomerTags() response. */
export const buildStatusTagMap = (customerTags = []) => {
    const map = {};
    (customerTags || []).forEach(t => {
        if (t.tag_group === 'Status') map[t.f_business_customer_id] = t.tag_name;
    });
    return map;
};
